
    /**
     * @description
     *  Lista de mime-types disponibles en el sistema.
     */

export enum MimeType {

    APPLICATION_JSON = "application/json",
    MICROSOFT_EXCEL_XLS = "application/vnd.ms-excel",
    MICROSOFT_EXCEL_XLSX = "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    APPLICATION_PDF = "application/pdf"
}
